import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { DatePipe } from '@angular/common';
import { StoreModule } from '@ngrx/store';

import { AppComponent } from './app/app.component';
import { routes } from './app/app-routing.module';
import { authInterceptor } from './app/utils/auth.interceptor'; // Your functional interceptor
import { reducers } from './app/utils/reducer';

bootstrapApplication(AppComponent, {
  providers: [
    // 1. Optimized Change Detection Layout
    provideZoneChangeDetection({ eventCoalescing: true }),

    // 2. Modern Functional HTTP Pipeline (Replaces withInterceptorsFromDi())
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),

    // 3. Central Application Routing Nodes Mapping
    provideRouter(routes, withComponentInputBinding()),

    // 4. State Management Integration Block
    importProvidersFrom(StoreModule.forRoot(reducers)),

    // 5. Global Core Utility Providers
    DatePipe
  ],
}).catch((err) => console.error(err));
